import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Container } from "reactstrap";
import { colorToggle } from "../store/actions/GlobalAction";
import { getOffers, getParentMenus } from "../store/actions/MenuActions";
import { restaurantVisitorAdd } from "../store/actions/orderAction";
import { getRestaurantsAction } from "../store/actions/restaurantsAction";
import {
  addCartDetails,
  clearCartAction,
  clearCartDetails,
} from "../store/actions/cartAction";
import MainNavigation from "../components/MainNavigation";
import firebase from "../config/firebase";
import MenuCategories from "../components/RestaurantMenu/MenuCategories";
import OffersCarousel from "../components/RestaurantMenu/OffersCarousel";
import MenuPageRoutes from "../components/RestaurantMenu/MenuPageRoute";
import HolidayNotice from "../components/RestaurantMenu/HolidayNotice";
import RestaurantProfile from "../components/RestaurantMenu/RestaurantProfile";
import RestaurantLoader from "../utils/RestaurantLoader";

const RestaurantHome = () => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const { darkMode } = useSelector((state) => state.global);
  const { uid } = useSelector((state) => state.authUser);
  const { restaurantsDetail } = useSelector((state) => state.restaurants);
  const { orderType, cartDetails } = useSelector((state) => state.cart);
  const { singleUser } = useSelector((state) => state.user);
  const { getMenusLoading, parentMenuData, offerLoading } = useSelector(
    (state) => state.parentMenu
  );

  const [isHoliday, setIsHoliday] = useState({
    isHoliday: false,
    title: "",
    storeTiming: false,
    type: "",
  });

  useEffect(() => {
    if (!id) {
      toast.warning("Link broken");
      dispatch(clearCartAction());
      dispatch(clearCartDetails());
      return history.push("/restaurants");
    }

    const prevRestID = cartDetails?.restaurantId;
    const hasOrderType = !!cartDetails?.orderType;

    if (prevRestID !== id) {
      dispatch(getRestaurantsAction(id));
      const existingCart = cartDetails || {};
      const updatedCart = {
        ...existingCart,
        restaurantId: id,
      };
      dispatch(addCartDetails(updatedCart));
      dispatch(clearCartAction());
    } else if (!hasOrderType) {
      dispatch(clearCartAction());
      toast.warning("Please Select Order Type");
      dispatch(clearCartAction());
      return history.push("/order-options");
    } else {
      dispatch(getRestaurantsAction(cartDetails?.restaurantId));
    }
  }, [dispatch, history, id, cartDetails]);

  useEffect(() => {
    const color = restaurantsDetail?.customerColor;
    if (color) {
      localStorage.setItem("mainColor", color);
      dispatch(colorToggle(color));
    }
  }, [dispatch, restaurantsDetail]);

  useEffect(() => {
    dispatch(getParentMenus(id));
  }, [dispatch, id]);

  useEffect(() => {
    let unsubscribe = () => {};
    (async () => {
      unsubscribe = await getOffers(id, dispatch);
    })();
    return () => unsubscribe();
  }, [dispatch, id]);

  useEffect(() => {
    if (id) {
      dispatch(
        restaurantVisitorAdd({
          createdAt: firebase.firestore.Timestamp.now(),
          restaurantID: id,
        })
      );
    }
  }, [dispatch, id]);

  return (
    <div style={{ minHeight: "100vh" }}>
      <div
        className={
          darkMode ? "restaurant__home__dark py-5" : "restaurant__home py-5"
        }
      >
        <HolidayNotice
          restaurant={restaurantsDetail}
          setIsHoliday={setIsHoliday}
        />

        <Container
          className={`restaurant__profile ${
            darkMode ? "screen_border" : "screen_border_dark"
          }`}
        >
          {uid && <MainNavigation title="" />}

          <RestaurantProfile restaurant={restaurantsDetail} />

          {getMenusLoading || offerLoading ? (
            <div className="text-center py-4">
              <RestaurantLoader message="Fetching Menus and Offers" />
            </div>
          ) : (
            <>
              <MenuCategories
                categories={parentMenuData}
                isHoliday={isHoliday}
              />
              <OffersCarousel isHoliday={isHoliday} />
            </>
          )}

          <MenuPageRoutes
            restaurantId={id}
            userId={uid}
            userType={singleUser?.id}
            orderType={orderType}
            isHoliday={isHoliday}
          />
        </Container>
      </div>
    </div>
  );
};

export default RestaurantHome;
